module.exports = __webpack_public_path__ + "media/images/dividend/ic_cc_mastercard-5ad7c68e2b976f7b4546e05d46ea23ea.svg";